import { render, staticRenderFns } from "./train_manage.vue?vue&type=template&id=b7e59142&scoped=true"
import script from "./train_manage.vue?vue&type=script&lang=js"
export * from "./train_manage.vue?vue&type=script&lang=js"
import style0 from "./train_manage.vue?vue&type=style&index=0&id=b7e59142&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e59142",
  null
  
)

export default component.exports